import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Utility } from 'src/app/core/common';

@Directive({
  selector: '[kp-numeric]',
  host: {
    '[attr.type]': 'Utility.iOS?"text":"number"',
    '[attr.inputmode]': 'Utility.iOS?"numeric":undefined',
    '(ngModelChange)': 'onModelChange($event)',
    '(input)': 'onInput()'
  }
})
export class NumericDirective {

  Utility = Utility;
  constructor(private formControl: NgControl, public renderer: Renderer2) {
  }


  onModelChange(val) {
    if (isNaN(val)) val = 0;
    let formatted = Utility.toEnDigits(val);
    if (val !== formatted) {
      this.formControl.viewToModelUpdate(formatted);
      this.formControl.control.updateValueAndValidity()
    }

  }
  onInput() {
    let val = this.formControl.value;
    val = Utility.toEnDigits(val);

    this.formControl.control.setValue(val);
    this.formControl.valueAccessor.writeValue(val);
    this.formControl.viewToModelUpdate(val);
    this.formControl.control.updateValueAndValidity()
  }


}
